import styled, { css } from 'styled-components';

export const StyledLink = styled.a<{ $variant: 'default' | 'inverse' }>(
  ({ theme, $variant }) => css`
    font-size: ${theme.fontSize[12]};
    font-weight: ${theme.fontWeight.regular};
    line-height: ${theme.lineHeight.lh5};
    color: ${$variant === 'inverse'
      ? theme.colors.brandBlue[500]
      : theme.textColor.textWhite};
    text-decoration: underline;
    white-space: nowrap;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover{
      color: ${theme.textColor.link};
    }
  `
);
